import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowCoolDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2840_4902",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 21,
		children: /* @__PURE__ */ _jsx("rect", {
			y: 20.5,
			width: 20,
			height: 20,
			transform: "rotate(-90 0 20.5)",
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2840_4902)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M17.9167 10.5L12.3559 16.0608L11.4648 15.1906L15.5304 11.125H9.57544V9.87496H15.5386L11.4856 5.80933L12.3559 4.93913L17.9167 10.5ZM7.90877 11.125H5.40877V9.87496H7.90877V11.125ZM3.74211 11.125H2.07544V9.87496H3.74211L3.74211 11.125Z",
			fill: "#4BA06E"
		})
	})]
});
export default SvgArrowCoolDown;
